export default {
	computed: {
		baseUrl () {
			return this.$store.getters.url
		}
	},
	methods: {
		getUrl1 (item) {
			console.log(item, /(http|https):\/\/([\w.]+\/?)\S*/.test(item))
			if (/(http|https):\/\/([\w.]+\/?)\S*/.test(item)) {
				return item
			}
			return this.baseUrl + item
		},
		addzero (n) {
			if (n <= 9) {
				return `0${n}`
			}
			return n
		},
		getTimestamp () {
			const myDate = new Date()
			const year = myDate.getFullYear() // 获取当前年
			const mon = myDate.getMonth() + 1 // 获取当前月
			const date = myDate.getDate() // 获取当前日
			const hours = myDate.getHours() // 获取当前小时
			const minutes = myDate.getMinutes() // 获取当前分钟
			const seconds = myDate.getSeconds() // 获取当前秒
			const now =
        year +
        '' +
        mon +
        '' +
        this.addzero(date) +
        '' +
        this.addzero(hours) +
        '' +
        this.addzero(minutes) +
        '' +
        this.addzero(seconds) +
        '' +
        new Date(this.getNowDate()).getTime()
			return now
		},
		getNowDate () {
			const data = new Date()
			const y = data.getFullYear()
			const M = data.getMonth() + 1
			const d = data.getDate()
			const h = data.getHours()
			const m = data.getMinutes()
			const s = data.getSeconds()
			console.log(d)
			return (
				y +
        '-' +
        this.addzero(M) +
        '-' +
        this.addzero(d) +
        ' ' +
        this.addzero(h) +
        ':' +
        this.addzero(m) +
        ':' +
        this.addzero(s)
			)
		},
		// 只允许输入字母和数字
		LetterAndNum (num, length) {
			// num -- 数值, limit -- 小数点后位数,  length -- 长度
			let str = num.toString().slice(0, length)
			// 正则替换
			str = str.replace(/[^\w]/g, '') // 只允许输入字母和数字
			return str
		},
		// 只允许数字 -- 订单号
		Num (num, length) {
			// num -- 数值, limit -- 小数点后位数,  length -- 长度
			let str = num.toString().slice(0, length)
			// 正则替换
			str = str.replace(/[^\d]/g, '') // 只允许输入字母和数字
			return str
		},
		// 金额校验
		oninput (num, limit, length) {
			// num -- 数值, limit -- 小数点后位数,  length -- 长度
			// if(num)
			let str = num.toString().slice(0, length)
			// str = str.slice(0,7)
			const len1 = str.substr(0, 1)
			const len2 = str.substr(1, 1)
			// 如果第一位是0，第二位不是点，就用数字把点替换掉
			if (str.length > 1 && len1 == 0 && len2 != '.') {
				str = str.substr(1, 1)
			}
			// 第一位不能是.
			if (len1 == '.') {
				str = ''
			}
			// 限制只能输入一个小数点
			if (str.indexOf('.') != -1) {
				const str_ = str.substr(str.indexOf('.') + 1)
				if (str_.indexOf('.') != -1) {
					str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1)
				}
			}
			// 正则替换
			str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
			if (limit / 1 === 1) {
				str = str.replace(/^\D*([0-9]\d*\.?\d{0,1})?.*$/, '$1') // 小数点后只能输 1 位
			} else {
				str = str.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1') // 小数点后只能输 2 位
			}
			return str
		}
	}
}
